import { createContext, useState, useMemo, useCallback } from 'react'
import { node } from 'prop-types'
import { api } from 'api'

export const folderContext = createContext({})

export const FolderProvider = ({ children }) => {
  const [byConnectorId, setByConnectorId] = useState({})
  const [boxFolders, setBoxFolders] = useState({})

  const fetchFolderByConnectorId = useCallback(
    id =>
      api.get(`/api/v1/account/connector/${id}/folders`).then(({ data }) => {
        setByConnectorId(prev => ({ ...prev, [id]: data.folders || data }))
        return data || []
      }),
    [],
  )

  const fetchBoxFolders = useCallback(
    (folderId, connectorId) => {
      if (!Object.values(boxFolders).some(folder => folder.parent === folderId))
        return api
          .get(`/api/v1/account/connector/${connectorId}/box/folders?folderId=${folderId}`)
          .then(resp => {
            setBoxFolders(prev =>
              resp.data.reduce((acc, i) => ({ ...acc, [i.id]: { ...i, parent: folderId } }), prev),
            )
            return resp
          })
      return new Promise(res => res())
    },
    [boxFolders, setBoxFolders],
  )

  const setFolderByConnectorId = useCallback((connectorId, newFolder) => {
    setByConnectorId(prev => {
      const folders = prev[connectorId].filter(folder => folder.id !== newFolder.id)
      folders.push(newFolder)
      return { ...prev, [connectorId]: folders }
    })
  })

  const value = useMemo(
    () => ({
      byConnectorId,
      fetchFolderByConnectorId,
      fetchBoxFolders,
      setFolderByConnectorId,
      boxFolders,
    }),
    [byConnectorId, fetchBoxFolders, setFolderByConnectorId, fetchFolderByConnectorId, boxFolders],
  )

  return <folderContext.Provider value={value}>{children}</folderContext.Provider>
}

FolderProvider.propTypes = {
  children: node.isRequired,
}
